// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"9eef6d73","93":"82e6de1e","188":"094c06bc","206":"30e16eba","250":"7e8a1311","453":"251e7a6a","557":"f8ac88ff","624":"0f2585c8","640":"dad57b1f","689":"92c5a148","703":"a484a09b","756":"dfd336f1","813":"6ffe0ee5","881":"cb937ea8"}[chunkId] + ".chunk.js";
};